import { render, staticRenderFns } from "./ReviewActivity.vue?vue&type=template&id=7c8f6aa8"
import script from "./ReviewActivity.vue?vue&type=script&lang=js"
export * from "./ReviewActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports